import React from 'react';
import { Menu } from 'antd';
import { isAppModule, PRODUCT_MODE_MAP } from '@utils/constants';
import { SPI_LABEL } from '@components/top-widget-panel/spi-panel/widgets/constants';
import { useAtomValue } from 'jotai';
import { contextTypeAtom } from '@src/atoms/page';

function ModalAnchor({
  navRefs,
  categoryOrder,
  listCategory,
  isAppSPIEnabled = false,
  style = {},
}) {
  const contextType = useAtomValue(contextTypeAtom);
  const currentListCategory = listCategory[contextType];
  const isAppContext = isAppModule || contextType === PRODUCT_MODE_MAP.APP;
  const handleClick = ({ key }) => {
    navRefs[key].scrollIntoView({ behavior: 'smooth' });
  };

  if (isAppContext && !isAppSPIEnabled) {
    categoryOrder = categoryOrder.filter((categoryKey) => categoryKey !== SPI_LABEL.APP);
  }

  const items = categoryOrder.map((categoryKey) => ({
    label: currentListCategory[categoryKey] || categoryKey,
    key: categoryKey,
  }));

  return (
    <Menu
      style={{ minWidth: '150px', ...style }}
      items={items}
      onClick={handleClick}
      selectable={false}
    />
  );
}

export default ModalAnchor;
